import Support from './Support/Support'
export const ROUTES = [
  {
    component: Support,
    isProtected: true,
    showMenu: true,
    path: '/support',
    slug: 'support',
    title: 'support',
    redirectTo: '/auth/login',
    isExact: true,
  },
]
